module.exports = __webpack_public_path__ + "static/media/furniture-appliance-rentals.8e9d5c55.svg";